module.exports = __webpack_public_path__ + "src/assets/img/share/tips/extroversion/d886f12ce85587a9316d07d7c912491d.png";